<script>
export default {
  name: 'ImageViewerModal',
  props: {
    src: {
      type: String,
      required: true,
    },
    authorDisplay: {
      type: String,
      default: '',
    },
    authorPictureUrl: {
      type: String,
      default: null,
    },
  },
  emits: ['close'],
  mounted() {
    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.$emit('close');
    };
    document.addEventListener('keydown', this._onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this._onKeydown);
  },
  methods: {
    async download() {
      const response = await fetch(this.src);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      link.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<template>
  <div class="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex flex-col" @click.self="$emit('close')">
    <div class="flex items-center justify-between p-4">
      <div class="flex items-center gap-2">
        <img
          v-if="authorPictureUrl"
          :src="authorPictureUrl"
          :alt="authorDisplay"
          class="h-8 w-8 rounded-full object-cover" />
        <span
          v-else
          class="h-8 w-8 rounded-full bg-grey-700 text-white text-sm font-semibold flex items-center justify-center">
          {{ authorDisplay[0] }}
        </span>
        <span class="text-white font-medium">{{ authorDisplay }}</span>
      </div>
      <div class="flex items-center gap-2">
        <button
          class="h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white"
          @click="download">
          <span class="ga-icon ga-download text-xl" />
        </button>
        <button
          class="h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white"
          @click="$emit('close')">
          <span class="ga-icon ga-supprimer text-xl" />
        </button>
      </div>
    </div>

    <div class="flex-1 flex items-center justify-center min-h-0 p-4" @click.self="$emit('close')">
      <img :src="src" alt="" class="max-h-full max-w-full object-contain" />
    </div>
  </div>
</template>

<style scoped></style>
